import { PropsWithChildren } from 'react';

import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

import i18n from '~lib/i18n';
import AppTheme from '~themes/theme';

import PageLayout from './page/pageLayout';
import GeneralLoader from '../components/loaders/generalLoader';

type GeneralLoaderWrapperProps = PropsWithChildren & {
	title?: string;
};

const GeneralLoaderWrapper = ({
	title = i18n.t('loading', { ns: 'status' }),
	children,
}: GeneralLoaderWrapperProps) => {
	const theme = AppTheme();

	return (
		<ThemeProvider theme={theme}>
			<PageLayout hideHeaderInfo hideBreadcrumbs>
				<CssBaseline />
				{children}
				<GeneralLoader title={title} />
			</PageLayout>
		</ThemeProvider>
	);
};

export default GeneralLoaderWrapper;
